import { UserMapDataProvider } from "../../data-provider/user-map.dp";
import * as _ from "lodash";
import * as angular from "angular";

import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { HouseDataProvider } from "../../data-provider/house.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Campaign } from "../../models/campaign.model";
import { Effort } from "../../models/effort.model";
import { Filter } from "../../models/filter.model";
import { Group } from "../../models/group.model";
import { House } from "../../models/house.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { BoundsHelperService } from "./bounds.helper";
import { MapHelperService } from "./map.helper";
import { MarkerService } from "./marker.helper";
import { PolygonService } from "./polygon.helper";
import { SearchUtils } from "../../helper/search.helper";
import { Utils } from "../../helper/utils.helper";
import { User } from "../../models/user.model";
import { ViewOptionsService } from "./view-options.helper";
import { focusMapSearchInput } from "./map-search-focus";
import { ScreenUtils } from "../../helper/screen.helper";
import { FilterService } from "../../services/filter.service";
import { ProspectorDataProvider } from "../../data-provider/prospector.dp";

declare const google;

let app = angular.module("map", ["uiGmapgoogle-maps", "boundsService"]);

app.config((uiGmapGoogleMapApiProvider: any, $mdGestureProvider: any) => {
    uiGmapGoogleMapApiProvider.configure({
        key: window["__env"].google_maps_key,
        v: "3.63",
        libraries: "geometry,visualization,drawing",
    });

    $mdGestureProvider.skipClickHijack();
});

let MapComponent = {
    selector: "vcMap",
    templateUrl: "/angular/components/map/map.component.html",
    bindings: {},
    controller: class MapController {
        private readonly $scope: any;
        private readonly $location: any;
        private $cookies: any;
        private readonly $filter: any;
        private $mdBottomSheet: any;
        private searchUtils: SearchUtils;
        private navigationBarService: NavigationBarHelperService;
        private uiGmapGoogleMapApi: any;
        private uiGmapIsReady: any;
        private dialog: DialogUtils;
        private readonly $interval: any;
        private readonly $q: any;
        private toast: ToastUtils;
        private readonly $http: any;
        private readonly $timeout: any;
        private boundsHelperService: BoundsHelperService;
        private mapHelperService: MapHelperService;
        private markerService: MarkerService;
        private groupDataProvider: GroupDataProvider;
        private filterDataProvider: FilterDataProvider;
        private polygonService: PolygonService;
        private readonly __env: any;
        private campaignDataProvider: CampaignDataProvider;
        private effortDataProvider: EffortDataProvider;
        private userMapDataProvider: UserMapDataProvider;
        private modelsUtils: any;
        private houseDataProvider: HouseDataProvider;
        private permissionProvider: PermissionCheck;
        private userDataProvider: UserDataProvider;

        private houseMarker: any;
        public myLocationMarker: any;
        public onMyLocation: boolean = false;
        public justClickedMyLocation: boolean = false;
        public showMyLocationButton: boolean = false;
        public loadingMarkers: boolean = false;
        public createHouseMode: boolean = false;
        public isLeaderView: boolean;
        public windowOpts: any = {};
        public efforts: Effort[];
        public selectedEffort: Effort;
        public activeCampaign: Campaign;
        public show_geostats: boolean;
        public geocodeStats: any;
        public map: any;
        public selectedMarker: any;
        public selectedFeature: any;
        public viewOptions: any;
        public hasBoundsChanged = false;
        public drawing: boolean = false;
        public prospectorMode: boolean = false;
        public totalCount: number | null = null;
        public boundsCount: number | null = null;
        public allMarkers = {
            clusters: [],
            control: {},
        };
        public lastLoaded = {
            bounds: null,
            zoom: null,
        };
        public canceller: any;
        public filter: Filter;
        public showMap: boolean;
        public groups: Group[] = [];
        public selectedHouse: House;
        public selectedCoords: object;
        public tempClusters: object[] = [];
        public firstLoadDone: boolean;
        public showSampleBanner: boolean;
        public selectedHid: string | number;
        public drawingManagerOptions: any;
        public eventHandler: object;
        public previousFilter: Filter;
        public group: Group;
        public mapEvents: object;
        public markerEvents: object;
        public pinDropMarkerEvents: object;
        public gmap: any;
        public centerUpdate: any;
        public kmlLayers = {};
        public timeoutCode: any;
        public newHouseObject: House;
        public reverseGeocoding: boolean = false;
        public houseSaving: boolean = false;
        public searchMode: boolean = false;
        public showViewOptions: boolean = false;
        public searchText: string = "";
        public hideCreateHouseWindow: boolean = true;
        public showingSampleData: boolean = false;
        public streetViewModeActive: boolean = false;
        public savingGroup: boolean = false;
        public routeParams: any;
        public userMarkers?: any[];
        public userMarkerEvents: any;
        public selectedUser: any;
        public userWindowOpts: any = {};
        public sideNavContent: any;
        public sideNavWidth: string;
        public resizeMoveX: any;
        public resizeDragHandle: HTMLElement;
        public polygonGroups: Group[];
        private filterService: FilterService;
        private prospectorDataProvider: ProspectorDataProvider;

        private _mouseMoveListener = this.mouseMoveListener.bind(this);
        private _mouseUpListener = this.mouseUpListener.bind(this);
        private polygonListener: any;
        private viewOptionsHelper: ViewOptionsService;
        public polygonEvents: any;
        public screen: ScreenUtils;

        constructor(
            $scope: any,
            $location: any,
            $filter: any,
            $cookies: any,
            $mdBottomSheet: any,
            SearchUtils: SearchUtils,
            NavigationBarHelperService: NavigationBarHelperService,
            uiGmapGoogleMapApi: any,
            uiGmapIsReady: any,
            DialogUtils: DialogUtils,
            $interval: any,
            $q: any,
            ToastUtils: ToastUtils,
            FilterService: FilterService,
            $http: any,
            $timeout: any,
            BoundsHelperService: BoundsHelperService,
            MapHelperService: MapHelperService,
            MarkerService: MarkerService,
            GroupDataProvider: GroupDataProvider,
            FilterDataProvider: FilterDataProvider,
            ProspectorDataProvider: ProspectorDataProvider,
            PolygonService: PolygonService,
            __env: any,
            CampaignDataProvider: CampaignDataProvider,
            EffortDataProvider: EffortDataProvider,
            ModelsUtils: any,
            HouseDataProvider: HouseDataProvider,
            PermissionCheck: PermissionCheck,
            UserMapDataProvider: UserMapDataProvider,
            Utils: Utils,
            ViewOptionsService: ViewOptionsService,
            ScreenUtils: ScreenUtils,
            $window: any
        ) {
            this.$scope = $scope;
            this.$location = $location;
            this.$filter = $filter;
            this.$cookies = $cookies;
            this.$mdBottomSheet = $mdBottomSheet;
            this.searchUtils = SearchUtils;
            this.navigationBarService = NavigationBarHelperService;
            this.screen = ScreenUtils;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
            this.uiGmapIsReady = uiGmapIsReady;
            this.dialog = DialogUtils;
            this.$interval = $interval;
            this.$q = $q;
            this.toast = ToastUtils;
            this.$http = $http;
            this.$timeout = $timeout;
            this.filterService = FilterService;
            this.boundsHelperService = BoundsHelperService;
            this.mapHelperService = MapHelperService;
            this.markerService = MarkerService;
            this.groupDataProvider = GroupDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.viewOptionsHelper = ViewOptionsService;
            this.polygonService = PolygonService;
            this.__env = __env;
            this.campaignDataProvider = CampaignDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.modelsUtils = ModelsUtils;
            this.houseDataProvider = HouseDataProvider;
            this.permissionProvider = PermissionCheck;
            this.activeCampaign = this.campaignDataProvider.activeCampaign;
            this.activeCampaign.getLocalStorage();
            this.userMapDataProvider = UserMapDataProvider;
            this.polygonService.setWindowOpts(this.windowOpts);
            this.viewOptions = this.viewOptionsHelper.getViewOptions();
            this.prospectorDataProvider = ProspectorDataProvider;
            this.polygonService.setProspectorMode(this.prospectorMode);

            Utils.accessCheck();
            Utils.runWootric();

            this.navigationBarService.setFilterBarOpen(false);
            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts;
                });
            this.effortDataProvider
                .getSelectedEffort()
                .then((effort?: Effort) => {
                    if (effort) {
                        this.selectedEffort = effort;
                    }
                });
            this.markerEvents = {
                click: this.markerClicked.bind(this),
                dragend: (event) => {
                    this.pinDragged();
                },
            };
            this.pinDropMarkerEvents = {
                dragend: (event) => {
                    this.pinDragged();
                },
            };

            this.$scope.$watch(
                () => this.prospectorDataProvider.reloadMap,
                (newValue: boolean, oldValue: boolean) => {
                    if (newValue == true && oldValue == false) {
                        this.prospectorDataProvider.reloadMap = false;
                        this.loadMarkers(true, null, true);
                    }
                },
                true
            );

            // The Prospector panel also closes itself (its X, Escape) through
            // the open binding, bypassing toggleProspecting(); without this the
            // service stays in Prospector mode and the turf count is skipped.
            this.$scope.$watch(
                () => this.prospectorMode,
                (prospectorMode: boolean) => {
                    this.polygonService.setProspectorMode(prospectorMode);
                }
            );

            let searchPromise: any = null;
            this.searchUtils.setSearchBar(
                "Search houses and people",
                null,
                (searchText: string) => {
                    const deferred = this.$q.defer();
                    if (searchPromise) searchPromise.resolve("user cancelled");
                    searchPromise = this.$q.defer();
                    let search = searchText;
                    if (search != "") {
                        this.$http({
                            url: this.__env.apiUrl() + "/houseoccupant/search",
                            method: "GET",
                            params: {
                                val: search,
                                houses: true,
                            },
                            timeout: searchPromise.promise,
                        }).then((response: any) => {
                            if (
                                !response ||
                                !response.data ||
                                !response.data.data
                            )
                                deferred.reject();
                            let housesArray = response.data.data.slice(0, 49);
                            angular.forEach(housesArray, (house: House) => {
                                house.displayValue =
                                    this.searchFormatter(house);
                            });
                            deferred.resolve(housesArray);
                        });
                    } else {
                        searchPromise.resolve("");
                        deferred.resolve("");
                    }

                    return deferred.promise;
                }
            );

            this.polygonEvents = {
                click: this.polygonClicked.bind(this),
            };

            if (this.$cookies.get("hideGeocodeSnackbar") != "true") {
                this.permissionProvider.getFeaturePermissions().then(() => {
                    if (
                        this.activeCampaign.campaignstatusid == 2 ||
                        this.activeCampaign.campaignstatusid == "4"
                    ) {
                        this.show_geostats = true;
                        this.houseDataProvider
                            .geocodeStats()
                            .then((data: object[]) => {
                                this.geocodeStats = data;
                                if (
                                    this.geocodeStats &&
                                    this.geocodeStats.geocoded > 0 &&
                                    this.permissionProvider.hasPermission(
                                        "NOT_CANVASSER"
                                    )
                                ) {
                                    this.showGeocodeSnackbar();
                                }
                            });
                    }
                });
            }

            this.permissionProvider.getFeaturePermissions().then(() => {
                if (
                    this.viewOptions.userMarkers &&
                    this.permissionProvider.hasPermission(
                        "CANVASSER_TRACKING"
                    ) &&
                    this.permissionProvider.hasPermission("NOT_CANVASSER")
                ) {
                    this.userMapDataProvider
                        .getMapMarkers()
                        .then((markers: any[]) => {
                            this.userMarkers = markers;
                        });
                }
            });

            this.searchUtils.selectedItemChange = (result: any) => {
                if (!result) {
                    this.clearSelection();
                } else {
                    this.selectAndPanToHouse(result);
                }
            };
            this.canceller = this.$q.defer();
            this.filterDataProvider.setPage("map");
            this.filter = this.filterDataProvider.appliedFilter;
            setTimeout(() => (this.showMap = true), 500);

            this.$scope.$watch(
                () => this.filter,
                (newValue: Filter, oldValue: Filter) => {
                    if (
                        this.gmap &&
                        newValue &&
                        !angular.equals(
                            newValue.nonEmptyValues(),
                            oldValue.nonEmptyValues()
                        )
                    ) {
                        this.totalCount = null;
                        this.loadMarkers(true);
                        if (this.polygonService.drawing) {
                            this.polygonService.getCountInPolygon();
                        }
                    }
                },
                true
            );

            this.$scope.$watch(
                () =>
                    this.selectedHouse
                        ? this.selectedHouse.activities
                        : undefined,
                () => {
                    if (this.selectedHouse) {
                        let lastCsid = null;
                        if (this.selectedHouse.activities.length) {
                            lastCsid = this.selectedHouse.activities[0].cssid;
                        }
                        this.selectedMarker.model.canvass_status = lastCsid;
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.viewOptions,
                (newValue: any, oldValue: any) => {
                    this.updateMapViewOptions(newValue, oldValue);
                },
                true
            );

            this.centerUpdate = this.$interval(() => {
                this.boundsHelperService.saveMapCenter(
                    this.hasBoundsChanged,
                    this.viewOptions,
                    this.sideNavWidth
                );
            }, 2000);

            this.campaignDataProvider.hasSampleData().then((hasSampleData) => {
                this.showingSampleData = hasSampleData;
            });

            this.userWindowOpts.ariaLabel = "user-marker";
            this.userMarkerEvents = {
                click: (marker: any, eventName: any, model: any) => {
                    this.userWindowOpts.show = false;
                    this.$timeout(() => {
                        if (model.uid) {
                            this.userWindowOpts.show = true;
                            this.userWindowOpts.pixelOffset = {
                                height: -5,
                                width: 0,
                            };
                            this.userWindowOpts.coords = model.coords;
                            if (model instanceof User) {
                                this.selectedUser = model;
                            } else {
                                this.selectedUser =
                                    this.modelsUtils.user(model);
                            }
                        } else {
                            this.userWindowOpts.show = false;
                            this.map.zoom += 2;
                            this.map.center = model.coords;
                        }
                    }, 50);
                },
            };
        }

        $onInit() {
            this.routeParams = this.$location.search();

            this.activeCampaign.getLocalStorage();
            if (
                this.activeCampaign &&
                this.activeCampaign.localInfo &&
                this.activeCampaign.localInfo.map &&
                this.activeCampaign.localInfo.map.viewOptions
            ) {
                this.viewOptions = _.merge(
                    this.viewOptions,
                    this.activeCampaign.localInfo.map.viewOptions
                );
                if (
                    this.viewOptions.groups &&
                    typeof this.viewOptions.groups == "boolean"
                ) {
                    this.viewOptions.groups = [];
                }
            }

            this.sideNavContent = document.querySelector(
                ".map-side-info-content"
            );

            this.$timeout(() => {
                if (
                    this.sideNavContent &&
                    this.activeCampaign.localInfo &&
                    this.activeCampaign.localInfo.map &&
                    this.activeCampaign.localInfo.map.sideNavWidth
                ) {
                    this.sideNavContent.style.width = angular.copy(
                        this.activeCampaign.localInfo.map.sideNavWidth
                    );
                    this.sideNavWidth = angular.copy(
                        this.activeCampaign.localInfo.map.sideNavWidth
                    );
                } else {
                    this.sideNavWidth = "400px";
                }
                this.resizeDragHandle = document.getElementById("resize");
                this.initializeResizeableSideNav();
            }, 100);

            this.mapEvents = {
                bounds_changed: this.boundsChanged.bind(this),
                idle: this.idle.bind(this),
                click: (event: any, eventName: any, model: any) => {
                    this.handleMapClick(model[0].latLng);
                },
            };

            this.$scope.$watch(
                () => this.selectedUser,
                (newValue: User | null, oldValue: User | null) => {
                    if (oldValue) {
                        if (!newValue.uid) {
                            this.userWindowOpts.show = false;
                        } else {
                            this.userWindowOpts.show = true;
                        }
                    }
                },
                true
            );
        }

        clearSelection(): void {
            this.selectedHid = null;
            this.userWindowOpts.show = false;
            this.resetSelectedMarker();
            this.selectedCoords = null;
            this.polygonService.resetPolygons();
            this.clearPolygon();
        }

        sideNavIsOpen(): boolean {
            if (
                (this.polygonService.selectedPolygonGroup ||
                    this.selectedCoords ||
                    this.selectedHid) &&
                (!this.polygonService.editPolygonModeActive ||
                    !this.screen.smallScreen())
            ) {
                return true;
            } else {
                return false;
            }
        }

        polygonClicked(
            polygon: object,
            eventName: string = "",
            model: object = null,
            args: object = null,
            polygonGroup: Group = null
        ): void {
            this.clearSelection();
            this.polygonService.polygonClicked(
                polygon,
                eventName,
                model,
                args,
                polygonGroup
            );
        }

        multiPolygonClicked(event: any, polygonGroup: Group = null): void {
            this.clearSelection();
            this.polygonService.multiPolygonClicked(polygonGroup);
        }

        initializeResizeableSideNav(): void {
            this.resizeDragHandle.addEventListener("mousedown", (e) => {
                this.initializeResizeMouseMoveEvents();
            });
        }

        userIsOnline(user?: User): boolean {
            if (this.selectedUser) {
                return this.selectedUser.isOnline();
            }
            return false;
        }

        initializeResizeMouseMoveEvents(): void {
            document.addEventListener("mousemove", this._mouseMoveListener);
            document.addEventListener("mouseup", this._mouseUpListener);
        }

        mouseMoveListener(e: any) {
            this.resizeMoveX = e.x;
            let mainNavigationSideNav = document.getElementById(
                "mainNavigationSideNav"
            );
            this.sideNavWidth =
                this.resizeMoveX -
                mainNavigationSideNav.getBoundingClientRect().width -
                document.getElementById("resize").getBoundingClientRect()
                    .width /
                    2 +
                "px";
            document.getElementById("map-side-info-content").style.width =
                this.sideNavWidth;
            e.preventDefault();
        }

        mouseUpListener(e: any) {
            document.removeEventListener("mousemove", this._mouseMoveListener);
            document.removeEventListener("mouseup", this._mouseUpListener);

            this.activeCampaign.localInfo.map.sideNavWidth = angular.copy(
                this.sideNavWidth
            );
            this.activeCampaign.saveLocalStorage();
            this.$scope.$broadcast("resized");
        }

        showGeocodeSnackbar(): any {
            let messsage: string =
                "You have used " +
                this.$filter("number")(this.geocodeStats.geocoded) +
                " out of the " +
                this.$filter("number")(this.geocodeStats.limit) +
                " house geocoding credits available to you during your trial.";

            return this.toast
                .snackbar(messsage, "Don't show again")
                .then(() => {
                    this.$cookies.put("hideGeocodeSnackbar", "true");
                });
        }

        clickMyLocation(): void {
            this.getCurrentLocation(true);
            if (this.myLocationMarker) {
                this.panToCurrentLocation(this.myLocationMarker.coords);
            } else {
                this.getCurrentLocation(true);
            }
        }

        getCurrentLocation(pan: boolean = false) {
            navigator.geolocation.getCurrentPosition(
                (response: GeolocationPosition) => {
                    if (pan) {
                        this.panToCurrentLocation(response.coords);
                    } else {
                        this.setMyLocationMarker(response.coords);
                    }
                },
                (response) => {
                    console.log(response);
                },
                {
                    maximumAge: 600000,
                    timeout: 5000,
                    enableHighAccuracy: true,
                }
            );
        }

        panToCurrentLocation(coords: any) {
            this.justClickedMyLocation = true;
            this.$timeout(() => {
                this.justClickedMyLocation = false;
            }, 700);

            this.map.center = {
                latitude: coords.latitude,
                longitude: coords.longitude,
            };

            if (this.map.zoom < 19) {
                this.map.zoom = 19;
            }

            this.setMyLocationMarker(this.map.center);
        }

        setMyLocationMarker(coords: any) {
            this.myLocationMarker = {
                id: 2,
                coords: {
                    latitude: coords.latitude,
                    longitude: coords.longitude,
                },
                options: {
                    icon: {
                        url: "/img/map/markers/myLocation.svg",
                        scaledSize: new google.maps.Size(25, 25),
                    },
                    draggable: false,
                    zIndex: 99998,
                },
            };
            if (
                this.map.center.longitude ==
                    this.myLocationMarker.coords.longitude &&
                this.map.center.latitude ==
                    this.myLocationMarker.coords.latitude
            ) {
                this.onMyLocation = true;
            }
        }

        selectAndPanToHouse(house: any) {
            if (house.hlatitude && house.hlongitude) {
                this.map.center = {
                    latitude: house.hlatitude,
                    longitude: house.hlongitude,
                };
                this.map.zoom = 18;
            }
            this.resetSelectedMarker();
            this.selectedMarker = {
                model: house,
            };
            this.selectedHid = house.hid;
            this.loadMarkers(true);
        }

        toggleSearchMode(): void {
            this.searchMode = !this.searchMode;
            if (this.searchMode) {
                this.$timeout(() => {
                    focusMapSearchInput();
                }, 50);
            }
        }

        toggleProspecting(): void {
            if (this.permissionProvider.hasPermission("PROSPECTOR_L2")) {
                this.prospectorMode = !this.prospectorMode;
                this.polygonService.setProspectorMode(this.prospectorMode);

                if (this.prospectorMode) {
                    this.searchMode = false;
                    this.navigationBarService.setFilterBarOpen(false);
                    this.toggleCreateHouseMode(false);
                    this.togglePolygonClickMode(false);
                    this.toggleDrawingMode(this.viewOptions.drawingMode, false);
                }
            } else {
                this.dialog.show({
                    component: "vc-prospector-add-on-dialog",
                    escapeToClose: true,
                    hasBackdrop: false,
                    clickOutsideToClose: true,
                    locals: {},
                    size: "large",
                    ariaLabel: "Prospector Add-On",
                });
            }
        }

        handleMapClick(latLng: any): void {
            if (this.createHouseMode) {
                this.addMarker(latLng);
            } else {
                if (!this.polygonService.editPolygonModeActive) {
                    this.clearSelection();
                }
            }
        }

        addMarker(latLng: any): void {
            this.houseMarker = {
                id: Math.floor(Math.random() * (99999 - 80000 + 1) + 80000),
                coords: {
                    latitude: latLng.lat(),
                    longitude: latLng.lng(),
                },
                options: {
                    icon: {
                        url: "/img/map/markers/newHouse.svg",
                        scaledSize: new google.maps.Size(36, 49),
                    },
                    draggable: true,
                },
            };

            this.reverseGeocoding = true;
            this.addCreateHouseInfoWindow(this.houseMarker);

            this.$timeout(() => {
                this.reverseGeocode();
            }, 50);
        }

        reverseGeocode() {
            this.reverseGeocoding = true;
            this.mapHelperService.reverseGeocode(
                this.houseMarker.coords.latitude,
                this.houseMarker.coords.longitude,
                (address: any) => {
                    this.newHouseObject = this.modelsUtils.house(address || {});
                    this.reverseGeocoding = false;
                },
                () => {
                    this.newHouseObject = this.modelsUtils.house({});
                    this.reverseGeocoding = false;
                }
            );
        }

        createHouse(): void {
            if (!this.houseSaving && !this.reverseGeocoding) {
                this.houseSaving = true;
                this.newHouseObject.hlatitude =
                    this.houseMarker.coords.latitude.toFixed(7);
                this.newHouseObject.hlongitude =
                    this.houseMarker.coords.longitude.toFixed(7);
                this.newHouseObject.hlocationtype = "Manual";

                this.houseDataProvider.create(this.newHouseObject).then(
                    (house: any) => {
                        house.id = house.hid + 10000;
                        house.coords = {
                            latitude: house.hlatitude,
                            longitude: house.hlongitude,
                        };
                        house.first_house = house.coords;
                        house.size = 1;
                        house.type = "house";

                        house.options = this.markerService.markerOption(house);

                        this.cancelCreateHouse();
                        this.houseMarker = this.modelsUtils.house({});
                        this.allMarkers.clusters.push(house);

                        this.houseSaving = false;
                        this.boundsCount += 1;
                        this.totalCount += 1;
                        let address = this.newHouseObject.formatAddressLine1();
                        this.toast.success(
                            address != ""
                                ? address + " created"
                                : "House" + " created."
                        );
                    },
                    (error: any) => {
                        this.houseSaving = false;
                        if (error.message == "Address already exist") {
                            this.windowOpts.show = false;
                            this.houseMarker = null;
                            this.setMapCursor("crosshair");
                            this.toast
                                .info(
                                    this.newHouseObject.formatAddressLine1() +
                                        " already exists",
                                    null,
                                    "View"
                                )
                                .then(() => {
                                    this.houseDataProvider
                                        .info(error.hid)
                                        .then((house: House) => {
                                            this.selectAndPanToHouse(house);
                                        });
                                });
                        } else {
                            this.toast.error(
                                "Something went wrong, please try again or contact " +
                                    this.__env.support_email
                            );
                        }
                    }
                );
            }
        }

        pinDragged(): void {
            this.reverseGeocode();
        }

        openViewHouseDialog(hid: string | number, ev?: object): void {
            this.dialog.show({
                component: "vc-view-house",
                targetEvent: ev,
                skipHide: true,
                clickOutsideToClose: true,
                scope: this.$scope,
                ariaLabel: "View House",
                size: "large",
                locals: {
                    selectedHid: hid,
                    selectedHouse: null,
                },
            });
        }

        addCreateHouseInfoWindow(marker: any): void {
            this.windowOpts.show = true;
            this.setMapCursor("default");
            this.windowOpts.type = "create_house";
            this.hideCreateHouseWindow = true;
            this.windowOpts.pixelOffset = {
                height: -70,
                width: 0,
            };
            this.windowOpts.coords = angular.copy(marker.coords);

            this.$scope.$apply();
            this.$timeout(() => {
                this.$scope.$apply();
            }, 500);
        }

        cancelCreateHouse(): void {
            this.hideCreateHouseWindow = true;
            this.windowOpts.show = false;
            this.houseMarker = null;
            if (this.createHouseMode) {
                this.setMapCursor("crosshair");
            } else {
                this.setMapCursor("default");
            }
        }

        toggleDrawingMode(mode: string, enabled: boolean): void {
            this.polygonService.toggleDrawingMode(
                this.viewOptions.drawingMode,
                enabled
            );
            if (enabled) {
                this.toggleCreateHouseMode(false);
                this.togglePolygonClickMode(false);
            } else if (!this.createHouseMode) {
                this.togglePolygonClickMode(true);
            }
        }

        toggleCreateHouseMode(enable?: boolean): void {
            if (enable == false || this.createHouseMode) {
                this.cancelCreateHouse();
                this.createHouseMode = false;
                this.setMapCursor("default");
                if (!this.polygonService.drawing) {
                    this.togglePolygonClickMode(true);
                }
            } else {
                this.polygonService.cancelDrawingPolygon();
                this.createHouseMode = true;
                this.setMapCursor("crosshair");
                this.togglePolygonClickMode(false);
            }
        }

        togglePolygonClickMode(enabled: boolean): void {
            if (enabled) {
                const polygonService = this.polygonService;
                this.polygonListener = this.gmap.data.addListener(
                    "click",
                    (event: any) => {
                        const feature = event.feature;
                        const geometry = feature.getGeometry();
                        let properties = {};

                        feature.forEachProperty((value: any, property: any) => {
                            properties[property] = value;
                        });

                        if (this.selectedFeature) {
                            const fillColor =
                                this.selectedFeature.getProperty("fill") ||
                                "green";
                            const fillOpacity =
                                this.selectedFeature.getProperty(
                                    "fill-opacity"
                                ) || 0.55;
                            const strokeColor =
                                this.selectedFeature.getProperty("stroke") ||
                                "black";
                            const strokeWeight =
                                this.selectedFeature.getProperty(
                                    "stroke-width"
                                ) || 1;
                            const strokeOpacity =
                                this.selectedFeature.getProperty(
                                    "stroke-opacity"
                                ) || 1;
                            this.gmap.data.overrideStyle(this.selectedFeature, {
                                fillColor: fillColor,
                                fillOpacity: fillOpacity,
                                strokeColor: strokeColor,
                                strokeWeight: strokeWeight,
                                strokeOpacity: strokeOpacity,
                            });
                        }

                        // Check if the clicked feature is already selected, if so, deselect it
                        if (this.selectedFeature === feature) {
                            this.selectedFeature = null; // Deselect
                        } else {
                            // Apply the selected style
                            this.gmap.data.overrideStyle(feature, {
                                fillColor: "yellow",
                                fillOpacity: 0.55,
                                strokeWeight: 1,
                                strokeColor: "orange",
                            });
                            this.selectedFeature = feature;
                        }

                        if (!this.createHouseMode) {
                            if (geometry.getType() === "Polygon") {
                                let pointArrays = geometry.getArray();
                                let largestArray = pointArrays.reduce(
                                    (max: any, current: any) =>
                                        current.getArray().length >
                                        max.getArray().length
                                            ? current
                                            : max
                                );
                                polygonService.polygonFromShape(
                                    largestArray,
                                    properties
                                );
                            }
                            if (geometry.getType() === "MultiPolygon") {
                                polygonService.multiPolygonFromShape(
                                    geometry.getArray(),
                                    properties
                                );
                            }
                        }
                    }
                );
            } else {
                google.maps.event.clearListeners(this.gmap.data, "click"); // This will remove all click event listeners
                this.polygonListener = null;
            }
            this.viewOptionsHelper.setGeoJsonStyle(enabled);
        }

        setMapCursor(cursor: string): void {
            this.map.options.draggableCursor = cursor;
        }

        setSelectedEffortField(selectedEffort: Effort): void {
            this.selectedEffort = selectedEffort;
            this.effortDataProvider.setSelectedEffort(selectedEffort);
            this.loadMarkers(true);
        }

        underGeocodeLimit(): boolean {
            return (
                parseInt(this.geocodeStats.geocoded) <
                parseInt(this.geocodeStats.limit)
            );
        }

        searchFormatter(input: House): string | void {
            if (angular.isUndefined(input)) {
                return;
            }
            let address =
                (input.hunit ? input.hunit + " " : "") +
                (input.hnumber ? input.hnumber + " " : "") +
                (input.hname ? input.hname + " " : "") +
                (input.haddress ? input.haddress + ", " : "") +
                (input.hcity ? input.hcity + ", " : "") +
                (input.hstate ? input.hstate : "");
            if (angular.isDefined(input.hoid) && input.hoid) {
                return input.hofname + " " + input.holname + " - " + address;
            }
            return address;
        }

        toggleViewOptions(): void {
            this.showViewOptions = !this.showViewOptions;
            let mapOptions = this.map.options ?? null;

            this.$mdBottomSheet.show({
                templateUrl:
                    "/angular/components/map/view-options-bottom-sheet.component.html",
                controller: "ViewOptionsBottomSheetController",
                locals: {
                    mapOptions: mapOptions,
                    polygonGroups: this.polygonGroups,
                    viewOptions: this.viewOptions,
                    kmlFiles: this.viewOptionsHelper.kmlFiles,
                    uploader: this.viewOptionsHelper.getUploader(),
                    hasCanvasserTrackingPermission:
                        this.permissionProvider.hasPermission(
                            "CANVASSER_TRACKING"
                        ),
                },
                disableParentScroll: true,
                escapeToClose: false,
                parent: "#mainMapSection",
            });
        }

        updateMapViewOptions(newValue: any, oldValue: any) {
            if (this.map) {
                this.loadGroups();
                this.kmlLayers = this.viewOptionsHelper.toggleKMLLayers(
                    this.gmap
                );
                if (
                    newValue.markers != oldValue.markers ||
                    newValue.maxMarkersBeforeCluster !=
                        oldValue.maxMarkersBeforeCluster ||
                    newValue.userMarkers != oldValue.userMarkers ||
                    newValue.userMarkerType != oldValue.userMarkerType
                ) {
                    this.loadMarkers(true);
                    this.loadUserMarkers();
                }
                this.viewOptionsHelper.setViewOptions(
                    newValue,
                    oldValue,
                    this.map.options
                );
            }
        }

        loadGroups(turfCreated: boolean = false): void {
            this.groups.splice(0, this.groups.length);
            this.groupDataProvider.groupsAll = null;
            this.groupDataProvider.allGroupsPromise = null;
            this.groupDataProvider
                .getAllGroups()
                .then((groups: Array<Group>) => {
                    this.groups = groups.sort((a: Group, b: Group) =>
                        a.gname.localeCompare(b.gname, undefined, {
                            sensitivity: "base",
                        })
                    );
                    if (turfCreated) {
                        this.polygonService.turfCreated();
                    }

                    if (!this.polygonGroups) {
                        this.polygonGroups =
                            this.polygonService.getPolygonGroups();
                    } else {
                        this.polygonGroups.splice(0, this.polygonGroups.length);
                        angular.forEach(
                            this.polygonService.getPolygonGroups(),
                            (group) => {
                                this.polygonGroups.push(group);
                            }
                        );
                    }

                    let selectedGroup: Group;
                    if (this.routeParams.gid) {
                        angular.forEach(groups, (group) => {
                            if (group.gid == this.routeParams.gid) {
                                selectedGroup = group;
                            }
                        });
                    } else if (this.polygonService.selectedPolygonGroup) {
                        selectedGroup = angular.copy(
                            this.polygonService.selectedPolygonGroup
                        );
                    }
                    if (selectedGroup) {
                        if (selectedGroup.isTurfList()) {
                            angular.forEach(
                                this.polygonGroups,
                                (polygonGroup) => {
                                    if (polygonGroup.gid == selectedGroup.gid) {
                                        this.polygonService.polygonClicked(
                                            polygonGroup.points,
                                            null,
                                            null,
                                            null,
                                            polygonGroup
                                        );
                                        this.map.center = this.getCenterPoint(
                                            polygonGroup.points
                                        );
                                    }
                                }
                            );
                        }
                    }
                });
        }

        setLastLoaded(lastloaded: any): void {
            this.lastLoaded.zoom = lastloaded.zoom;
            let extendedBounds = this.boundsHelperService.expandBounds(
                lastloaded.bounds,
                this.gmap
            );
            this.lastLoaded.bounds = new google.maps.LatLngBounds(
                new google.maps.LatLng(
                    extendedBounds.southwest.latitude,
                    extendedBounds.southwest.longitude
                ),
                new google.maps.LatLng(
                    extendedBounds.northeast.latitude,
                    extendedBounds.northeast.longitude
                )
            );
        }

        shouldReloadMarkers(bounds: object, zoom: number): boolean {
            if (!this.viewOptions.markers) return false;
            return this.boundsHelperService.shouldReloadMarkers(
                bounds,
                zoom,
                this.lastLoaded
            );
        }

        selectMarker(model: any, marker: any): void {
            if (model.size == 1) {
                if (this.selectedMarker) {
                    this.resetSelectedMarker();
                }
                model.options.icon = {
                    url: "/img/map/markers/dyellow.svg",
                    scaledSize: this.markerService.getScaledSize(
                        this.map.zoom,
                        true
                    ),
                };
                //double set to make sure it actually changes. Large numbers don't watch all markers.
                if (marker) {
                    marker.setIcon(model.options.icon);
                    marker.setZIndex(99999);
                }
            } else {
                model.options.icon = {
                    url: this.markerService.generateCircleIcon(
                        model.size,
                        true
                    ),
                    scaledSize: new google.maps.Size(34, 34),
                };
                marker.setIcon(model.options.icon);
                marker.setZIndex(99999);
            }
            this.selectedMarker = {
                marker: marker,
                model: model,
            };
        }

        markerClicked(
            marker: any,
            eventName: string,
            model: any,
            args: any
        ): void {
            if (!this.polygonService.drawing) {
                this.clearSelection();
                if (model.size == 1) {
                    this.selectHouse(model.hid);
                    this.$timeout(() => {
                        this.selectMarker(model, marker);
                    }, 30);
                } else {
                    if (model.cluster) {
                        this.map.center = model.coords;
                        this.boundsHelperService.setNextZoomLevel();
                    } else {
                        //it's a point load markers on that point
                        this.selectedCoords = model.coords;
                        this.$timeout(() => {
                            this.selectMarker(model, marker);
                        }, 30);
                    }
                }
            }
        }

        loadMarkers(
            forceRefresh?: boolean,
            selectedHid?: number,
            forceCount?: boolean
        ): void {
            if (!this.gmap) return;

            this.loadingMarkers = true;
            this.tempClusters = [];

            let bounds = this.gmap.getBounds();
            let zoom = this.gmap.getZoom();
            if (!forceRefresh) {
                if (angular.equals({}, bounds)) {
                    this.loadingMarkers = false;
                    return;
                }
                if (!this.shouldReloadMarkers(bounds, zoom)) {
                    this.loadingMarkers = false;
                    return;
                }
            }
            if (this.canceller) {
                this.canceller.resolve("user cancelled");
                this.canceller = this.$q.defer();
            }

            if (this.viewOptions.markers) {
                let mapBounds = JSON.stringify(
                    this.boundsHelperService.expandBounds(bounds, this.gmap)
                );
                this.filter["app_type"] = ["Walk"];
                if (this.timeoutCode) {
                    this.$timeout.cancel(this.timeoutCode);
                }
                this.timeoutCode = this.$timeout(() => {
                    this.$http({
                        url: this.__env.apiUrl() + "/house/map/",
                        method: "GET",
                        params: {
                            bounds: mapBounds,
                            shouldCluster: this.viewOptions.shouldCluster,
                            maxMarkersBeforeCluster:
                                this.viewOptions.maxMarkersBeforeCluster,
                            filters: this.filter.nonEmptyValues(),
                            count: forceCount ? null : this.totalCount,
                            boundsCount: this.boundsCount,
                            effort: this.selectedEffort
                                ? this.selectedEffort.id
                                : null,
                            zoom: zoom,
                        },
                        timeout: this.canceller.promise,
                    }).then((response: object) => {
                        this.firstLoadDone = true;
                        let lastLoaded = {
                            bounds: _.cloneDeep(bounds),
                            zoom: zoom,
                        };
                        this.setLastLoaded(lastLoaded);

                        const json = response["data"];
                        if (json.success) {
                            if (json.hasOwnProperty("count")) {
                                this.totalCount = parseInt(json.count);
                            }
                            this.boundsCount = parseInt(json.countInBounds);
                            for (let i: number = 0; i < json.data.length; i++) {
                                json.data[i].id = json.data[i].hid + 10000;

                                if (
                                    this.selectedHid &&
                                    json.data[i].hid == this.selectedHid
                                ) {
                                    this.selectedMarker = {
                                        model: json.data[i],
                                    };
                                }
                                json.data[i].options =
                                    this.markerService.getMarkerOption(
                                        json.data[i],
                                        this.selectedMarker
                                    );
                                this.tempClusters.push(json.data[i]);
                                if (json.data[i].sample == "1") {
                                    this.showSampleBanner = true;
                                }
                            }
                            this.loadingMarkers = false;

                            if (
                                this.map.center.latitude == 0 ||
                                this.map.center.longitude == 0
                            ) {
                                this.map.center = this.getCenterPoint(
                                    json.data
                                );
                                if (this.map.center.latitude != 0) {
                                    this.map.zoom = 11;
                                }
                            }
                        }
                        this.allMarkers.clusters = this.tempClusters;
                        this.loadingMarkers = false;

                        if (this.selectedHid) {
                            this.$timeout(() => {
                                this.selectHouse(this.selectedHid);
                            }, 550);
                        }
                    });
                }, 400);
            } else {
                this.firstLoadDone = true;
                this.allMarkers.clusters = this.tempClusters;
                this.loadingMarkers = false;
            }
        }

        loadUserMarkers(): void {
            this.permissionProvider.getFeaturePermissions().then((): void => {
                if (
                    this.viewOptions.userMarkers &&
                    this.permissionProvider.hasPermission(
                        "CANVASSER_TRACKING"
                    ) &&
                    this.permissionProvider.hasPermission("NOT_CANVASSER")
                ) {
                    this.userMapDataProvider.setFilters(
                        new Filter({ search: "" }),
                        this.boundsHelperService.expandBounds(
                            this.gmap.getBounds(),
                            this.gmap
                        ),
                        this.viewOptions.userMarkerType
                    );

                    this.userMapDataProvider
                        .getMapMarkers()
                        .then((markers: any[]): void => {
                            this.userMarkers = markers;
                        });
                }
            });
        }

        getCenterPoint(markers: any[]): object {
            if (markers.length === 0) {
                return { latitude: 0, longitude: 0 }; // Default to center of the world if no markers
            }

            let totalLat = 0;
            let totalLng = 0;

            let divider = 0;

            markers.forEach(function (marker) {
                if (marker.latitude != 0 && marker.longitude != 0) {
                    let multiplier = 1;
                    let numHouses = marker.size ? parseInt(marker.size) : 1;

                    if (numHouses && numHouses > 1) {
                        multiplier = numHouses;
                    }

                    totalLat +=
                        (marker.latitude ?? marker.coords.latitude) *
                        multiplier;
                    totalLng +=
                        (marker.longitude ?? marker.coords.longitude) *
                        multiplier;

                    divider += numHouses;
                }
            });

            const avgLat = totalLat / divider;
            const avgLng = totalLng / divider;

            return { latitude: avgLat, longitude: avgLng };
        }

        idle(data: any): void {
            this.loadMarkers();
        }

        houseUpdated(house: House): void {
            if (this.selectedHid == house.hid) {
                let clusters = this.allMarkers.clusters;
                for (const { key, value } of clusters) {
                    const element = value;
                    if ((element.hid = house.hid)) {
                        const coords = {
                            latitude: house.hlatitude,
                            longitude: house.hlongitude,
                        };
                        if (element.coords != coords) {
                            element.coords = element.first_house = coords;
                            clusters[key] = element;

                            this.map.center = coords;
                            this.map.zoom = 18;

                            this.resetSelectedMarker();
                            this.selectedMarker = {
                                model: element,
                            };
                            this.selectHouse(house.hid);
                        }
                        break;
                    }
                }
            }
            this.loadMarkers(true);
        }

        houseChanged(): void {
            this.clearHouse();
            this.loadMarkers(true);
        }

        clearHouse(): void {
            this.selectedHid = null;
            this.resetSelectedMarker();
        }

        clearPolygon(): void {
            if (this.selectedFeature) {
                const fillColor =
                    this.selectedFeature.getProperty("fill") || "green";
                const fillOpacity =
                    this.selectedFeature.getProperty("fill-opacity") || 0.55;
                const strokeColor =
                    this.selectedFeature.getProperty("stroke") || "#333333";
                const strokeWeight =
                    this.selectedFeature.getProperty("stroke-width") || 1;
                const strokeOpacity =
                    this.selectedFeature.getProperty("stroke-opacity") || 1;
                this.gmap.data.overrideStyle(this.selectedFeature, {
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                    strokeColor: strokeColor,
                    strokeWeight: strokeWeight,
                    strokeOpacity: strokeOpacity,
                });
            }
        }

        selectHouse(hid: string | number): void {
            //Don't clear all because we need selected coords so we can navigate back to the house list.
            this.polygonService.selectedPolygonGroup = null;
            this.selectedHid = hid;
        }

        resetSelectedMarker(): void {
            if (this.selectedMarker) {
                if (this.selectedMarker.model)
                    this.selectedMarker.model.options =
                        this.markerService.getMarkerOption(
                            this.selectedMarker.model,
                            this.selectedMarker,
                            true
                        );
                if (this.selectedMarker.marker)
                    this.selectedMarker.marker.setOptions(
                        this.markerService.getMarkerOption(
                            this.selectedMarker.model,
                            this.selectedMarker,
                            true
                        )
                    );
                this.selectedMarker = null;
            }
        }

        boundsChanged(): void {
            if (!this.justClickedMyLocation) {
                this.onMyLocation = false;
            }
            this.hasBoundsChanged = true;
        }

        initMap(): void {
            this.campaignDataProvider.getOrganisations().then(() => {
                this.activeCampaign.getLocalStorage();
                if (!this.activeCampaign.localInfo) {
                    this.activeCampaign.localInfo = { map: {} };
                    this.activeCampaign.saveLocalStorage();
                }
                if (!this.activeCampaign.localInfo.map) {
                    this.activeCampaign.localInfo.map = {};
                }
                let options = null;
                if (
                    this.activeCampaign.localInfo.map &&
                    this.activeCampaign.localInfo.map.options
                ) {
                    options = this.activeCampaign.localInfo.map.options;
                }
                let center =
                    this.activeCampaign.localInfo.map.center &&
                    this.activeCampaign.localInfo.map.center.latitude &&
                    this.activeCampaign.localInfo.map.center.longitude
                        ? this.activeCampaign.localInfo.map.center
                        : null;
                this.loadMap(
                    center,
                    this.activeCampaign.localInfo.map.zoom ?? 1,
                    options
                );
                return;
            });
        }

        loadMap(center?: object, zoom?: number, options?: any): void {
            this.uiGmapGoogleMapApi.then((map) => {
                let styles = this.viewOptionsHelper.getMapStyles(
                    this.viewOptions
                );
                if (!zoom) zoom = 12;
                this.map = {
                    center: center ?? { latitude: 0, longitude: 0 },
                    control: {},
                    zoom: zoom ?? 1,
                    options: {
                        draggableCursor: "default",
                        mapTypeId:
                            options && options.mapTypeId
                                ? options.mapTypeId
                                : "roadmap",
                        styles: styles,
                    },
                    // Must be an object from the start: angular-google-maps only
                    // keeps bounds in sync by mutating an existing object on the
                    // map's idle event (it never creates one), and the Prospector
                    // builds its queries from it. The old "{} crashes the
                    // google.maps.Map constructor" problem is handled inside
                    // angular-google-maps.js, which no longer passes bounds to
                    // the constructor (not a valid MapOption).
                    bounds: {},
                };
                this.boundsHelperService.setMap(this.map);
                this.markerService.setMap(this.map);

                this.uiGmapIsReady.promise().then(() => {
                    this.gmap = this.map.control.getGMap();
                    this.polygonService.setGmap(this.gmap);
                    this.viewOptionsHelper.setGmap(this.gmap);
                    this.viewOptionsHelper.resetKMLLayers();
                    this.polygonService.setMap(this.map);
                    this.viewOptionsHelper.loadKMLDocuments(this.gmap);
                    this.gmap.setOptions(this.boundsHelperService.getOptions());
                    this.loadMarkers(true);
                    this.initializeMapEvents(this.gmap);
                    this.loadUserMarkers();

                    if (!this.activeCampaign.localInfo) {
                        this.activeCampaign.localInfo = { map: {} };
                        this.activeCampaign.saveLocalStorage();
                    }
                    if (!this.activeCampaign.localInfo.map) {
                        this.activeCampaign.localInfo.map = {
                            center: this.map.center,
                            zoom: this.map.zoom,
                            options: this.map.options,
                            viewOptions: this.viewOptions,
                            sideNavWidth: this.sideNavWidth,
                        };
                        this.activeCampaign.saveLocalStorage();
                    }

                    this.loadGroups();
                });

                this.drawingManagerOptions =
                    this.polygonService.getDrawingManagerOptions();
                this.eventHandler = this.polygonService.getPolygonEvents();
                this.$timeout(() => {
                    this.showMyLocationButton = true;

                    navigator.permissions &&
                        navigator.permissions
                            .query({ name: "geolocation" })
                            .then((PermissionStatus) => {
                                if ("granted" === PermissionStatus.state) {
                                    this.getCurrentLocation();
                                }
                            });
                }, 550);
            });
        }

        initializeMapEvents(map): void {
            google.maps.event.addListener(
                map.getStreetView(),
                "visible_changed",
                () => {
                    if (map.getStreetView().getVisible()) {
                        this.toggleCreateHouseMode(false);
                        this.polygonService.cancelDrawingPolygon();
                        this.streetViewModeActive = true;
                    } else {
                        this.streetViewModeActive = false;
                    }
                }
            );

            google.maps.event.addListener(map, "zoom_changed", () => {
                this.viewOptionsHelper.setGeoJsonStyle(
                    !(this.polygonService.drawing || this.createHouseMode)
                );
            });

            this.togglePolygonClickMode(true);
        }

        openGroupModal(ev: any): void {
            if (!this.polygonService.groupCountLoading) {
                if (
                    this.polygonService.selectedPolygon.houseoccupants < 20000
                ) {
                    this.group = this.modelsUtils.group({
                        points: this.polygonService.selectedPolygon.points,
                        gstatus: this.permissionProvider.hasPermission(
                            "APPROVAL_NEEDED"
                        )
                            ? "Pending"
                            : "Active",
                    });
                    this.dialog
                        .show({
                            component: "vc-create-group",
                            targetEvent: ev,
                            scope: this.$scope,
                            locals: {
                                group: this.group,
                                assign: false,
                                autoSplitAssign: false,
                                street: null,
                                properties:
                                    this.polygonService.polygonProperties,
                            },
                        })
                        .then((resultGroup: Group) => {
                            if (this.polygonService.fromShape) {
                                this.windowOpts.show = false;
                                this.polygonService.fromShape = false;
                            }
                            resultGroup.created = true;
                            this.viewOptions.groups.push({
                                gid: resultGroup.gid,
                                selected: true,
                            });
                            this.addGroupMembers(resultGroup, false);
                        });
                } else {
                    this.listTooBig();
                }
            }
        }

        refreshList(
            group: Group,
            dynamic: boolean,
            updateFilters: boolean
        ): void {
            let data = { filters: this.filter.nonEmptyValues() };
            data["filters"]["turf_cut"] = true;
            data["points"] = group.points;
            this.groupDataProvider.getCount(data).then((response: any) => {
                if (updateFilters) {
                    group.filters = angular.copy(data.filters);
                }
                if (dynamic && updateFilters) {
                    this.filterDataProvider
                        .deleteGroupFilter(parseInt(group.gid))
                        .then(() => {
                            this.filterDataProvider
                                .createFilterWithGid(
                                    group.gid,
                                    group.gname,
                                    group.filters
                                )
                                .then(() => {
                                    this.updateGroup(
                                        group,
                                        response.houseoccupants,
                                        updateFilters
                                    );
                                });
                        });
                } else {
                    this.updateGroup(
                        group,
                        response.houseoccupants,
                        updateFilters
                    );
                }
            });
        }

        updateGroup(
            group: Group,
            num_houseoccupants?: number,
            updateFilters: boolean = true
        ): void {
            group.editable = false;
            let count =
                num_houseoccupants ??
                this.polygonService.selectedPolygon.houseoccupants;

            if (count < 20000) {
                this.savingGroup = true;
                let points = this.polygonService.getPointsFromPolygon(
                    this.polygonService.selectedPolygon
                );
                group.setData({
                    points: points,
                    houseoccupants:
                        this.polygonService.selectedPolygon.houseoccupants,
                });
                group.update().then(() => {
                    this.savingGroup = false;
                    this.addGroupMembers(
                        group,
                        false,
                        count,
                        true,
                        updateFilters
                    );
                    this.polygonService.enableEditPolygonMode(group, false);
                });
            } else {
                this.listTooBig();
            }
        }

        listTooBig(): void {
            const listToBigAlert = this.dialog
                .alert()
                .title(`List Too Big`)
                .htmlContent(
                    `<p class="no-margin">We cannot complete this action as it will result in exceeding the list size maximum of 20,000 ${this.__env.strings.voters}.</p>
                <p class="no-margin">List limits are in place to prevent excessive mobile data usage and provide an optimal experience using the mobile app.</p>`
                )
                .escapeToClose(false)
                .ok("Close");
            this.dialog.show(listToBigAlert);
        }

        addGroupMembers(
            group: Group,
            cancelDrawingGroup: boolean = true,
            count?: any,
            refreshList = false,
            updateFilters = true
        ): void {
            let filters: object;
            if (updateFilters || !group.filters) {
                filters = this.filter.nonEmptyValues();
            } else {
                filters = angular.copy(group.filters);
            }
            filters["bounds"] = group.gid;

            let data = {
                members: [
                    {
                        all_checked: true,
                        unchecked_items: [],
                        filters: filters,
                        data_type: "people",
                        constituent_filters_select_all: true,
                        checked_items_count:
                            count ??
                            this.polygonService.selectedPolygon.houseoccupants,
                    },
                ],
            };
            this.setMapCursor("progress");
            group.addMembers(data, this.dialog).then(
                () => {
                    this.setMapCursor("default");
                    if (cancelDrawingGroup)
                        this.polygonService.cancelDrawingPolygon();
                    if (this.polygonService.drawing) {
                        this.polygonService.cancelPolygonDrawMode();
                        this.polygonService.cancelFreeDrawMode();
                        this.polygonService.toggleDrawingMode(
                            this.viewOptions.drawingMode,
                            true
                        );
                    }
                    if (refreshList) {
                        this.toast.success("Turf list refreshed");
                    }
                },
                (data: object) => {
                    if (data["tooBig"]) {
                        this.listTooBig();
                    }
                    this.polygonService.toggleDrawingMode(
                        this.viewOptions.drawingMode,
                        false
                    );
                    this.polygonService.startDrawing();
                }
            );
        }

        listDeleted(): void {
            this.polygonService.removePolygonGroup();
            this.clearSelection();
        }
        listUpdated(): void {
            this.polygonService.setPolygonColor(
                this.polygonService.selectedPolygonGroup,
                true
            );
        }

        updateUser(user: User, event: Object): void {
            user.permissionid = user.permission.permissionid;
            this.dialog
                .show({
                    component: "vc-update-user-dialog",
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    locals: {
                        user: user,
                    },
                })
                .then((data: Object) => user.setData(data));
        }

        deleteUser(user: User, $event: Object): void {
            this.dialog
                .delete({
                    targetEvent: $event,
                    locals: {
                        title: "Delete User?",
                        bodyText: "They will be permanently deleted",
                    },
                })
                .then(() => {
                    this.userDataProvider.removeUser(user).then(
                        () => {
                            this.toast.success("User Deleted");
                            this.loadMarkers();
                            this.selectedUser.uid = null;
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

app.component(MapComponent.selector, MapComponent).controller(
    "ViewOptionsBottomSheetController",
    (
        $scope,
        $mdBottomSheet,
        ViewOptionsService,
        viewOptions,
        mapOptions,
        polygonGroups,
        kmlFiles,
        uploader,
        hasCanvasserTrackingPermission
    ) => {
        $scope.viewOptions = viewOptions;
        $scope.mapOptions = mapOptions;
        $scope.polygonGroups = polygonGroups;
        $scope.uploader = uploader;
        $scope.kmlFiles = kmlFiles;
        $scope.helper = ViewOptionsService;
        $scope.hasCanvasserTrackingPermission = hasCanvasserTrackingPermission;

        $scope.helper.initGroups(polygonGroups, true);

        $scope.close = function () {
            $mdBottomSheet.hide();
        };
    }
);
